import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
//import Input from "../../Components/CommonCommponents/Input";
import { Link, useNavigate } from "react-router-dom";
import AuthService from "../../Service.js/authService";
import toast from "react-hot-toast";
import { Input } from "antd";

const OtpVerification = (props) => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const {
    register,
    control,
    setError,
    setValue,
    reset,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });
  const handleLinkClick = () => {
    props.setIsVerifyOtp(false);
    props.setIsConfirm(true);
  };
  const handleClick = async () => {
    await AuthService.resendOtp()
      .then((response) => {
        if (response.data.success == true) {
          //setSingupResponse(response.data.data);
          toast.success("Sucessfully OTP is send");
        }
      })
      .catch((error) => {
        console.log("error", error);
        toast.error("Failed To Send OTP");
      });
  };

  const updateLocalStorageAndNavigate = (key, value, navigateTo) => {
    return new Promise((resolve) => {
      localStorage.setItem(key, value);
      resolve();
    }).then(() => {
      navigate(navigateTo);
    });
  };
  const onChange = (code) => {
    setOtp(code);
  };
  const sharedProps = {
    onChange,
  };

  const onSubmit = async (data) => {
    await AuthService.OtpVerification(otp)
      .then(
        (response) => {
          if (response.data.success == true) {
            toast.success("Sucessfully Verifiyed");
            localStorage.setItem(
              "candidate",
              JSON.stringify(response.data.data),
            );
            navigate("/");

            // updateLocalStorageAndNavigate(
            //   "candidate",
            //   JSON.stringify(response.data.data),
            //   "/"
            // );
          }
        },
        (error) => {
          const errorsObj = error.response.data.error_info;
          Object.keys(errorsObj).forEach((field) => {
            const messages = errorsObj[field];
            setError(field, {
              type: "server",
              message: messages.join(". "),
            });
          });
        },
      )
      .catch((error) => {
        console.log("error", error);
        toast.error("Failed To Register");
      });
  };
  return (
    <div className="w-full chart_div  mb-20">
      <div className="w-[100%] md-w-[90%] md:w-[75%] flex flex-col  mt-6 px-5 md:mt-0 md:px-0">
        <div className=" md:px-14 pb-10 w-full">
          <form onSubmit={handleSubmit(onSubmit)} className="">
            <div className="">
              <div className="mb-10">
                <p className="text-3xl md:text-5xl font-semibold">Sign Up</p>
              </div>

              <div className="w-full pb-2 ">
                <label className="block font-semibold text-lg mb-2">OTP</label>
                <div className="w-[100%] md:w-[85%] lg:w-[65%] flex flex-col  ">
                  <Input.OTP {...sharedProps} />
                  {/*                
                <Input
                  name="email_otp"    
                  control={control}
                  placeholder="Enter Email OTP"
                  rules={{
                    required: "This field is required",
                  }}
                  className="h-12  "
                /> */}
                </div>

                <div className="flex  mt-2 flex-row justify-end sm:items-center gap-1 sm:gap-2  w-[100%] md:w-[85%] lg:w-[65%]">
                  <p className="text-sm sm:text-base text-[#748396]">
                    Didn’t receive OTP?
                  </p>
                  <Link
                    className="text-sm sm:text-base text-[#0073E6] font-medium"
                    onClick={handleClick}
                  >
                    Resend OTP
                  </Link>
                </div>
              </div>

              <div className="">
                <button
                  // className="bg-[#1C4980] text-white w-full h-[42px] rounded-full text-sm sm:text-base font-semibold"
                  className="bg-[#0071DC] text-white font-bold px-10 h-[46px] rounded-lg"
                  type="submit"
                >
                  Confirm
                </button>
              </div>

              {/* <div className="flex flex-col items-center justify-center mt-10 sm:mt-14 text-center">
          <p className="text-base sm:text-lg md:text-xl text-[#748396]">
            Do you have any change in
          </p>
          <Link
            to="#"
            onClick={() => handleLinkClick()}
            className="text-base sm:text-lg md:text-xl text-[#0073E6] font-medium mt-1"
          >
            email or mobile? Back to Verification
          </Link>
        </div> */}
            </div>
          </form>
        </div>
      </div>

      {/* <div className=" flex items-center">
  <div className="w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl ml-24">
    <div className="flex flex-col items-center rounded-xl bg-white w-full p-6 sm:p-10 md:p-14">
      <form onSubmit={handleSubmit(onSubmit)} className="w-full">
        <div className="mb-10 sm:mb-16">
          <p className="text-2xl sm:text-3xl md:text-4xl font-semibold">
            OTP Verification
          </p>
          <p className="text-gray-500 text-sm sm:text-base font-normal mt-2">
            Check your email for the OTP!
          </p>
        </div>

        <div className="pt-2">
          <div className="w-full">
            <Input
              name="email_otp"
              label="Email OTP"
              control={control}
              placeholder="Enter Email OTP"
              rules={{
                required: "This field is required",
              }}
              className="h-12 w-full"
            />
          </div>

          <div className="flex flex-col sm:flex-row sm:justify-end sm:items-center mt-4 gap-1 sm:gap-2 text-center sm:text-right">
            <p className="text-sm sm:text-base text-[#748396]">
              Didn’t receive OTP?
            </p>
            <Link
              className="text-sm sm:text-base text-[#0073E6] font-medium"
              onClick={handleClick}
            >
              Resend OTP
            </Link>
          </div>
        </div>

        <div className="pt-8 sm:pt-10">
          <button
            // className="bg-[#1C4980] text-white w-full h-[42px] rounded-full text-sm sm:text-base font-semibold"
            className="bg-[#0071DC] text-white font-bold px-10 h-[46px] rounded-lg w-full sm:w-auto"
            type="submit"
          >
            Confirm
          </button>
        </div>

        <div className="flex flex-col items-center justify-center mt-10 sm:mt-14 text-center">
          <p className="text-base sm:text-lg md:text-xl text-[#748396]">
            Do you have any change in
          </p>
          <Link
            to="#"
            onClick={() => handleLinkClick()}
            className="text-base sm:text-lg md:text-xl text-[#0073E6] font-medium mt-1"
          >
            email or mobile? Back to Verification
          </Link>
        </div> 
      </form>
    </div>
  </div>
</div> */}
    </div>

    // <div className="pageContent w-full scrollbar-hide bg-red-300">
    //   <div className="w-full chart_div">
    //     <div className=" flex items-center justify-center rounded-xl bg-white  mb-20 bg-blue-200">
    //       <div>
    //         <form onSubmit={handleSubmit(onSubmit)}>
    //           <div className="mt-12 px-14 mb-20">
    //             <p className="text-2xl font-semibold">OTP verification</p>
    //             <p className="text-gray-500 text-base font-normal mt-2">
    //               Check your email for the otp !
    //             </p>

    //             <div className="pt-4">
    //               <div className="w-full ">
    //                 <Input
    //                   //name="username"
    //                   name="email_otp"
    //                   label="Email OTP"
    //                   control={control}
    //                   placeholder="Enter Email otp "
    //                   rules={{
    //                     required: "This field is required",
    //                   }}
    //                   className="h-12"
    //                 />
    //               </div>
    //               {/*
    //               <div className="w-full ">
    //                 <Input
    //                   name="mobile_otp"
    //                   label="Mobile number OTP"
    //                   placeholder="Enter mobile otp"
    //                   control={control}
    //                   rules={{
    //                     required: "This field is required",
    //                   }}
    //                   className="h-12"
    //                 />
    //               </div> */}
    //               <div className="flex justify-end mt-4">
    //                 <p className="text-base text-[#748396]">
    //                   Didn’t you receive OTP?
    //                 </p>
    //                 <Link
    //                   className="text-base text-[#0073E6]"
    //                   onClick={handleClick}
    //                 >
    //                   Resend OTP
    //                 </Link>
    //               </div>
    //             </div>

    //             <div className="pt-10">
    //               <button
    //                 className="bg-[#1C4980] text-white w-full h-[42px] rounded-full"
    //                 type="submit"
    //               >
    //                 Confirm
    //               </button>{" "}
    //             </div>
    //             <div className="flex items-center justify-center mt-16">
    //               <div>
    //                 <p className="text-xl text-[#748396]">
    //                   Do you have an any change in
    //                 </p>
    //                 <Link
    //                   to="#"
    //                   onClick={() => handleLinkClick()}
    //                   className="text-xl text-[#0073E6]"
    //                   //onClick={handleClick}
    //                 >
    //                   {" "}
    //                   email or mobile? Back to Verification
    //                 </Link>
    //               </div>
    //             </div>
    //           </div>
    //         </form>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};
export default OtpVerification;
